import React, { useEffect } from "react";
import "../styles/Root.css";
import { useTypewriter, Cursor } from "react-simple-typewriter";

const Hero = () => {
  const [text] = useTypewriter({
    words: ["Developer", "Web Developer", "Programmer", "Travaller"],
    loop: {},
    delay: 150,
    delaySpeed: 2000,
  });

  return (
    <div className="hero" id="hero">
      <div className="background-video">
        <video autoPlay muted loop>
          <source src="videos/bg-video-2.mp4" type="video/mp4" />
        </video>
        <div className="video-text">
          <h2 className="mb-lg-2 mb-sm-2 welcome-text">Welcome.</h2>
          <h1 className="typing-heading">
            I Am
            <span className="text">{text}</span>
            <span>
              <Cursor />
            </span>
          </h1>
          <h2 className="location-text mt-md-2 mt-sm-1 mb-md-4 mb-sm-2">
            based in Hyderabad,India
          </h2>
      
            <a href="#contact" className="hire-btn mt-md-2 mt-sm-1">

            Hire Me
            </a>
            
        </div>
      </div>
    </div>
  );
};

export default Hero;
